const Builder = require('./BuilderBase');

module.exports = class CustomizableVisibility extends Builder {
    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    constructor(properties) {
        const { title, accessTargetId, readonly } = properties;

        super('accessModifier_CustomizableVisibility', null, {
            title,
            accessTargetId,
            readonly
        });
    }
};
